import { ParentComponent } from 'solid-js';
import styles from './Card.module.scss';
import { themeClass } from '../ThemeProvider';

interface Props {
  class?: string;
  background?: boolean;
  rounded?: boolean;
  title?: string;
  theme?: 'light' | 'dark';
}

export const Card: ParentComponent<Props> = props => {
  return (
    <div
      class={themeClass(props.theme ? styles[props.theme] : styles.dark, styles.card, {
        [String(props.class)]: props.class !== undefined,
        [styles.background]: props.background,
        [styles.rounded]: props.rounded,
        [styles.hasTitle]: props.title ? true : false,
      })}
    >
      {props.title && <h2 class={styles.title}>{props.title}</h2>}
      <div class={styles.innerCard}>{props.children}</div>
    </div>
  );
};
